export enum TagTypeColor {
  status = '#FF0000',
  department = '#009DFF',
  stakeholder = '#DB00C9',
  remaining = '#000000',
  ok = '#229954',
}
